import { render, staticRenderFns } from "./updatePartnerBankInfo.vue?vue&type=template&id=0c8f3624"
import script from "./updatePartnerBankInfo.vue?vue&type=script&lang=js"
export * from "./updatePartnerBankInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports